exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-back[data-v-28ee62a9]{position:absolute;bottom:90px;left:10px;z-index:990;cursor:pointer;user-select:none;-webkit-filter:drop-shadow(1.5px 1.5px 1px #222);filter:drop-shadow(1.5px 1.5px 1px #222)}.button-back.disabled[data-v-28ee62a9]{display:none;pointer-events:none;cursor:default}.button-title[data-v-28ee62a9]{font-family:Nunito;position:absolute;bottom:4px;left:42px;z-index:999;font-size:13px;text-decoration:none;color:#000}@media only screen and (max-width:750px){.button-back[data-v-28ee62a9]{bottom:5px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-28ee62a9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ButtonReplay.vue
// module id = 74
// module chunks = 0